export var types = {
    INSTANTIATE_API: 'INSTANTIATE_API',
    SET_AUTH_TOKEN: 'SET_API_AUTHORIZATION_TOKEN',
    API_LOGIN: 'RX_MAT_API_LOGIN',
    API_LOGOUT: 'API_LOGOUT',
    API_EXECUTE: 'MAT_API_EXECUTE',
    API_EXECUTE_SUCCESS: 'MAT_API_EXECUTE_SUCCESS',
    GET_USER_INFO: 'GET_USER_INFO',
    SET_USER_INFO: 'SET_USER_INFO',
    GET_USER_PROPERTIES: 'GET_USER_PROPERTIES',
    SET_USER_PROPERTIES: 'SET_USER_PROPERTIES',
    API_CANCELLED: 'API_CANCELLED',
};
export var apiCancelled_AC = function () {
    return {
        type: types.API_CANCELLED,
    };
};
export var apiLogout_AC = function () {
    return {
        type: types.API_LOGOUT,
    };
};
export var apiExecute_AC = function (requests) {
    return {
        type: types.API_EXECUTE,
        payload: {
            requests: requests,
        },
    };
};
export var apiExecuteSuccess_AC = function (response) {
    return {
        type: types.API_EXECUTE_SUCCESS,
        payload: {
            response: response,
        },
    };
};
export var apiLogin_AC = function (login, password, app) {
    return {
        type: types.API_LOGIN,
        payload: {
            login: login,
            password: password,
            app: app,
        },
    };
};
export var instantiateAPI_AC = function (params) {
    return {
        type: types.INSTANTIATE_API,
        payload: params,
    };
};
export var setAuthToken_AC = function (token) {
    return {
        type: types.SET_AUTH_TOKEN,
        payload: { token: token },
    };
};
export var getUserInfo_AC = function () {
    return {
        type: types.GET_USER_INFO
    };
};
export var setUserInfo_AC = function (userInfo) {
    return {
        type: types.SET_USER_INFO,
        payload: {
            userInfo: userInfo
        }
    };
};
export var getUserProperties_AC = function (propertiesId) {
    return {
        type: types.GET_USER_PROPERTIES,
        payload: {
            propertiesId: propertiesId
        }
    };
};
export var setUserProperties_AC = function (userProperties) {
    return {
        type: types.SET_USER_PROPERTIES,
        payload: {
            userProperties: userProperties
        }
    };
};
//# sourceMappingURL=api.js.map